import {
  LOAD_ITEMS,
  RECEIVE_ITEMS,
  DELETE_ITEM,
  DELETED_ITEM_SUCCESS,
  DISMISS_WARNING,
  ITEM_TO_BAG,
  ITEM_TO_BAG_SUCCESS,
  SAVED_ITEMS_SDK_FAILURE,
  UPDATE_ITEM_INTENT,
  UPDATE_ITEM_SUCCESS,
  UPDATE_ITEM_FAILURE,
  LOAD_ITEMS_FAILURE,
  PURGE_DUPLICATE_SAVED_ITEM,
  LOADING_DATA_ON_PAGE_LOAD,
  RESET_INITIALISATION,
  SET_INITIAL_SORT,
  SORT_INTENT,
  SORT_FAILURE,
  SORT_SUCCESS,
  RECEIVE_BOARD_SHARE_ID,
  RECEIVE_BOARD_DETAILS,
  SET_VARIANT_OUT_OF_STOCK,
  RECEIVE_PAGINATION_ITEMS,
  SET_SORT_FOCUS,
  // back in stock specific below
  SHOW_SUCCESS_BANNER,
  SIZE_SELECT_ERROR,
  SHOW_WARNING_BANNER,
  // stock alerts opt in banner
  SET_SHOW_NOTIFICATIONS_OPT_IN_BANNER,
  SET_SHOW_NOTIFICATIONS_OPT_IN_SUCCESS_BANNER
} from "../constants";

import {
  SET_ITEM_SAVED_STATUS,
  CLEAR_ERRORS,
  ERROR
} from "../../common/constants";

import {
  deleteItem,
  deletedItemSuccess,
  setItemSavedStatus,
  dismissWarning,
  updateItemIndicatives,
  updateItemSuccess,
  updateItemFailure,
  itemToBag,
  itemToBagSuccess,
  loadItems,
  receiveItemsResetFromStart,
  receivePaginationItems,
  loadItemsFailure,
  savedItemsSdkFailure,
  error,
  clearErrors,
  purgeDuplicateSavedItem,
  loadingDataOnPageLoad,
  resetInitialisation,
  setInitialSort,
  sortIntent,
  sortFailure,
  sortSuccess,
  receiveBoardShareId,
  receiveBoardDetails,
  setVariantOutOfStock,
  setSortFocus,
  // back in stock specific below
  showSuccessBanner,
  setSizeSelectError,
  showWarningBanner,
  // stock alerts opt in banner
  setShowNotificationsOptInBanner
} from "./payloadCreators";

export default {
  [CLEAR_ERRORS]: clearErrors,
  [DELETE_ITEM]: deleteItem,
  [DELETED_ITEM_SUCCESS]: deletedItemSuccess,
  [SET_ITEM_SAVED_STATUS]: setItemSavedStatus,
  [DISMISS_WARNING]: dismissWarning,
  [ERROR]: error,
  [LOADING_DATA_ON_PAGE_LOAD]: loadingDataOnPageLoad,
  [ITEM_TO_BAG]: itemToBag,
  [ITEM_TO_BAG_SUCCESS]: itemToBagSuccess,
  [LOAD_ITEMS_FAILURE]: loadItemsFailure,
  [LOAD_ITEMS]: loadItems,
  [PURGE_DUPLICATE_SAVED_ITEM]: purgeDuplicateSavedItem,
  [RECEIVE_BOARD_SHARE_ID]: receiveBoardShareId,
  [RECEIVE_ITEMS]: receiveItemsResetFromStart,
  [RECEIVE_PAGINATION_ITEMS]: receivePaginationItems,
  [RECEIVE_BOARD_DETAILS]: receiveBoardDetails,
  [RESET_INITIALISATION]: resetInitialisation,
  [SAVED_ITEMS_SDK_FAILURE]: savedItemsSdkFailure,
  [SET_INITIAL_SORT]: setInitialSort,
  [SORT_INTENT]: sortIntent,
  [SORT_FAILURE]: sortFailure,
  [SORT_SUCCESS]: sortSuccess,
  [UPDATE_ITEM_FAILURE]: updateItemFailure,
  [UPDATE_ITEM_INTENT]: updateItemIndicatives,
  [UPDATE_ITEM_SUCCESS]: updateItemSuccess,
  [SET_VARIANT_OUT_OF_STOCK]: setVariantOutOfStock,
  [SET_SORT_FOCUS]: setSortFocus,
  [SHOW_SUCCESS_BANNER]: showSuccessBanner,
  [SIZE_SELECT_ERROR]: setSizeSelectError,
  [SHOW_WARNING_BANNER]: showWarningBanner,
  [SET_SHOW_NOTIFICATIONS_OPT_IN_BANNER]: setShowNotificationsOptInBanner,
  [SET_SHOW_NOTIFICATIONS_OPT_IN_SUCCESS_BANNER]:
    setShowNotificationsOptInBanner
};
